import _ from "lodash";
import { useNavigate } from "react-router";
import { Icon } from "@iconify/react";
import {
  tableEntryStyle,
  tableFirstColStyle,
} from "../../components/TableComponent";
import { limitString } from "../../utils/string";
import { getSecurityColor } from "../../utils/historicUtilities";
import { formatToReadableNumber } from "../../utils/currencyRoboto";
import Avatar from "../Utility/Avatar";
import { CaptableTag } from "../../components/AllotmentTag";
import RoundTag from "../../shared/RoundTag";
import { HStack } from "../../components/utils";

export function SecurityDetails(data: any) {
  return (
    <td className="flex flex-col pb-2 text-sm text-left">
      <div className="flex flex-col items-start gap-1">
        <div className="pr-2 text-left">
          {data.data.securityName !== "Total" ? (
            <p
              data-event-name="securityClassNameDetails"
              className={`${tableFirstColStyle}`}
            >
              {limitString(data.data.securityName || "", 24)}
            </p>
          ) : (
            ""
          )}
        </div>
        <div
          className={` ${
            data.data.securityName === "Total"
              ? "pt-2 cursor-pointer"
              : "ml-2 cursor-pointer"
          } `}
        >
          {data.data.securityName !== "Total" ? (
            <p
              className={`${getSecurityColor(
                data.data.securityType
              )}  text-xs text-center w-24 align-middle font-semibold leading-5 rounded-sm mb-1`}
            >
              {data.data.securityType}
            </p>
          ) : (
            ""
          )}
        </div>
      </div>
    </td>
  );
}

export function AllocationMethod(data: any) {
  return (
    <div className="pt-3 whitespace-nowrap">
      <p className={tableEntryStyle}>
        {data.value}
      </p>
    </div>
  );
}

export function AdjustedPrice(data: any) {
  return (
    <div className="pt-3 whitespace-nowrap">
      <p className={tableEntryStyle}>
        {data.value}
      </p>
    </div>
  );
}

export function AntiDilutionMethod(data: any) {
  return (
    <div className="pt-3 whitespace-nowrap">
      <p className={tableEntryStyle}>
        {data.value}
      </p>
    </div>
  );
}

export function AdditionalShares(data: any) {
  return (
    <HStack className="gap-2 items-center justify-between">
      <div className="whitespace-nowrap">
        <p className={tableEntryStyle}>
          {data.value}
        </p>
      </div>
      {data?.data?.allocationMethod === "Issue Shares" &&
        data?.colDef?.editable && (
        <Icon
          icon="mdi:pencil"
          className="ml-2 hover:cursor-pointer text-orange-500"
          width="24"
        />
      )}
    </HStack>
  );
}
